export const PROVIDER_STATUS_OPTIONS = [
  { value: 'APPROVED', label: '服务方已同意', type: 'success' },
  { value: 'REVIEWING', label: '服务方审核中', type: 'warning' },
  { value: 'NEED_SUPPLEMENT', label: '需用户补充材料', type: 'warning' },
  { value: 'REJECTED', label: '服务方已拒绝', type: 'danger' },
  { value: 'NOT_REQUIRED', label: '无需服务方审核', type: 'info' }
]

export const CHANNEL_STATUS_OPTIONS = [
  { value: 'PROCESSING', label: '渠道处理中', type: 'warning' },
  { value: 'SUCCESS', label: '渠道退款成功', type: 'success' },
  { value: 'FAILED', label: '渠道退款失败', type: 'danger' }
]

const PROVIDER_EXTRA = [{ value: 'SUPPLEMENTED', label: '用户已补充材料', type: 'warning' }]

const REFUND_STATUS = [
  { value: 'REQUESTED', label: '待核对', type: 'warning' },
  { value: 'MANUAL_REVIEW', label: '待人工处理', type: 'danger' },
  { value: 'APPROVED', label: '已同意待退款', type: 'warning' },
  { value: 'REFUNDED', label: '已退款', type: 'success' },
  { value: 'REJECTED', label: '已拒绝', type: 'info' },
  { value: 'FAILED', label: '退款失败', type: 'danger' }
]

function lookup(list, value, empty) {
  const key = String(value || '').toUpperCase()
  if (!key) return { label: empty, type: 'info' }
  return list.find(item => item.value === key) || { label: key, type: 'info' }
}

export const providerStatus = value => lookup(PROVIDER_STATUS_OPTIONS.concat(PROVIDER_EXTRA), value, '未核对')
export const channelStatus = value => lookup(CHANNEL_STATUS_OPTIONS, value, '未发起')
export const refundStatus = value => lookup(REFUND_STATUS, value, '-')
